export default [
    {
        path: "/terms-and-conditions",
        component: () => import("../pages/TermsAndConditions")
    }
]